import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import HttpClient from "./Services/HttpClient";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./router";
import Loader from "./components/Loader";
import { LoadScript } from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "./screen/redux/api/Constants";
import { GlobalProvider } from "./Services/PaginationGlobal";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  getPermissions,
  initPermissions,
} from "./screen/redux/api/PermissionManager";

function App() {
  const dispatch = useDispatch();
  const alertMessage = useSelector((state) => state.alertMessage);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryClient = new QueryClient();
  const token = localStorage.getItem("token");

  useEffect(() => {
    initPermissions();
    if (token) {
      HttpClient.defaults.headers.common["Authorization"] =
        `Bearer ${token}` || "";
    }

    HttpClient.interceptors.request.use(
      function (config) {
        // spinning start to show
        setLoading(true);
        return config;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    HttpClient.interceptors.response.use(
      function (response) {
        // spinning hide
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );

    getPermissions();
  }, []);

  const libraries = ["places"];

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <LoadScript googleMapsApiKey={GOOGLE_MAP_KEY} libraries={libraries}>
            {loading && <Loader />}
            <GlobalProvider>
              <AppRoutes />
            </GlobalProvider>
          </LoadScript>
        </LocalizationProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
